<!--
  转账
  lovi 2020-06-22
-->
<template>
  <div>
    <div class="scroll-wrapper">
      <div class="bg"></div>
      <scroll ref="scroll">
        <div class="column select-amount">
          <div class="title">
            <h3>{{ $t("transfer.theOtherAccount") }}</h3>
          </div>
          <van-field
            class="van-field-input"
            v-model="account"
            :placeholder="$t('transfer.eAccountPhone')"
            clearable
          >
          </van-field>
        </div>
        <div class="button-wrap">
          <van-button
            block
            type="primary"
            :loading="btnLoading"
            @click="checkTransferUser"
          >
            {{ $t("common.nextStep") }}
          </van-button>
          <p class="tips">{{ $t("transfer.transferTips") }}</p>
        </div>
      </scroll>
    </div>

    <transition name="slide">
      <amount
        v-if="amountFlag"
        :amountFlag.sync="amountFlag"
        :data="amountData"
      />
    </transition>
  </div>
</template>

<script>
import Amount from "./amount";
export default {
  components: {
    Amount
  },
  data() {
    return {
      account: "",
      btnLoading: false,
      amountFlag: false,
      amountData: {}
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    checkTransferUser() {
      //点击下一步，验证手机号
      let vm = this;
      //判断账号或手机号是否输入
      if (vm.account == "") {
        vm.$toast(vm.$t("transfer.enterTransferAccountOrPhone"));
        return;
      }
      //验证账号或手机号是否正确
      let params = {};
      params.master_account = vm.account;
      vm.btnLoading = true;
      vm.$post("/app/transfer/checkTransferUser", params, {
        alert: true
      }).then(res => {
        console.log("checkTransferUser", res);
        vm.btnLoading = false;
        if (res.code == 0) {
          vm.amountFlag = true;
          vm.amountData = res.data;
        } else {
          vm.$toast(res.msg);
        }
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.scroll-wrapper {
  background: #f4f4f4;
  .bg {
    height: 50px;
    background: linear-gradient(90deg, #2043ac, #130f73);
  }
}
.column {
  &.select-amount {
    padding: 15px;
    .title {
      padding: 0;
    }
  }
  .van-field-input {
    margin: 12px 0;
  }
}
</style>
